import React, { useEffect } from 'react';
const AutoScrollTop = ({ children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return <>{children}</>;
};
export default AutoScrollTop;
